const REJECT_TASK_REASON = {
	REJECT_BY_AGENT: 0,
	REJECT_BY_FINAL_CLIENT: 1,
};

export default REJECT_TASK_REASON;
